'use client';

import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef, useState } from 'react';
import './index.scss';
import RightArrow from './icons/index';

export default function Content({ id, data = {} }: ContentServerProps) {
    const prefixCls = 'index-pd-bar';
    const [top, setTop] = useState('0px');
    const observerRef = useRef<MutationObserver | null>(null);

    const watchCSSVariable = (variableName: string, callback: (cur: any, prev: any) => void, element = document.documentElement) => {
        let lastValue = getComputedStyle(element).getPropertyValue(variableName).trim() || 0;
        const observer = new MutationObserver(() => {
            const currentValue = getComputedStyle(element).getPropertyValue(variableName).trim();
            if (currentValue !== lastValue) {
                callback(currentValue, lastValue);
                lastValue = currentValue;
            }
        });
        observer.observe(element, {
            attributes: true,
            attributeFilter: ['style'],
        });
        return observer;
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const updateTop = () => {
                let h = 0;
                const header = document.querySelector('.ecoflow-frame-header') || document.querySelector('.global-header');
                if (header) {
                    const styles = window.getComputedStyle(header);
                    h += styles.position === 'sticky' ? header.clientHeight : 0;
                }
                setTop(`${h}px`);
            };

            updateTop();

            const observer = watchCSSVariable('--header-height', updateTop);
            observerRef.current = observer;
            return () => {
                if (observerRef.current) {
                    observerRef.current.disconnect();
                    observerRef.current = null;
                }
            };
        }
    }, []);

    return (
        <GloLayout className={`editor-${prefixCls} editor-${prefixCls}-${id}`} id={id} data={data} floorName={`${prefixCls}`}>
            <div
                className="pd-bar"
                style={
                    {
                        '--pd-bar-top-pc': top,
                        '--pd-bar-top-m': top,
                    } as React.CSSProperties
                }
                onClick={() => {
                    window.open('https://us.ecoflow.com/pages/early-prime-day-deals', '_blank');
                }}
            >
                <div className="pd-bar-box">
                    <div className="pd-bar-box-left">
                        <div className="pd-bar-box-left-img">
                            <EcoImg
                                pc={'https://websiteoss.ecoflow.com/figma-uploads/1780308484889-t7novg-compressed-Group%20161269473.png'}
                                h5={'https://websiteoss.ecoflow.com/figma-uploads/1780372651693-2n8f9l-compressed-Group%20161269473.png'}
                            ></EcoImg>
                        </div>
                        <div className="pd-bar-box-left-content">
                            <div className="pd-bar-box-left-title">Up to 63% Off</div>
                            <div className="pd-bar-box-left-desc">EcoFlow Prime Day Sale (June 8 - July 3)</div>
                            <div className="pd-bar-box-left-desc-m-btn">
                                Buy Now
                                <div className="pd-bar-box-left-desc-m-btn-arrow">
                                    <RightArrow />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pd-bar-box-right">
                        <EcoImg
                            className="pd-bar-box-right-img-btn"
                            pc={'https://websiteoss.ecoflow.com/figma-uploads/1780443000604-ofifph-compressed-Frame%20128720259.png'}
                        />
                        <EcoImg
                            className="pd-bar-box-right-img"
                            pc={'https://websiteoss.ecoflow.com/figma-uploads/1780382107626-8oze4c-compressed-Frame%20128720256.png'}
                            h5={'https://websiteoss.ecoflow.com/figma-uploads/1780382180397-91xzfl-compressed-Frame%20128720258.png'}
                        ></EcoImg>
                    </div>
                </div>
            </div>
        </GloLayout>
    );
}
